import React, { Component } from "react";

class ErrorBoundaries extends Component {
    constructor(props) {
        super(props);
        this.state = {
            hasError: false
        }
    }
    componentDidCatch(error, errorInfo) {
        this.setState({ hasError: true });
    }
    render() {
        if (this.state.hasError) {
            return <h1>oops something went wrong!</h1>
        } else {
            return this.props.children
        }
    }
}

export default ErrorBoundaries;